import { Badge, Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { NumberedBadgeList } from "../../../../Constant";
import { NUMBERED_BUDGE_DATA, NUMBERED_BUDGE_LIST } from "../../../../Data/UiKit/Lists";
import { LI, OL } from "../../../../AbstractElements";

const NumberedBadgeLists = () => {
  return (
    <Col xxl="4" md="6">
      <Card>
        <CommonCardHeader title={NumberedBadgeList} span={NUMBERED_BUDGE_DATA} />
        <CardBody>
          <OL className="list-group list-group-numbered">
            <LI className="d-flex justify-content-between align-items-start flex-wrap">
              <div className="ms-2 me-auto">Stella Nowland</div>
              <Badge color="warning" pill className="p-2">Freelance</Badge>
            </LI>
            {NUMBERED_BUDGE_LIST.map(({ title, color, text }, index) => (
              <LI className="d-flex justify-content-between align-items-start flex-wrap" key={index}>
                <div className="ms-2 me-auto">{title}</div>
                <Badge color={color} pill className="p-2">{text}</Badge>
              </LI>
            ))}
          </OL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default NumberedBadgeLists;
